export const iconFontAwesomeArrowsArrowTurnUp = (
	<i className="fa-solid fa-arrow-turn-up"></i>
);
